var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13L16.414 9.914C16.0389 9.53906 15.5303 9.32843 15 9.32843C14.4697 9.32843 13.9611 9.53906 13.586 9.914L4.5 19M3.5 1H17.5C18.6046 1 19.5 1.89543 19.5 3V17C19.5 18.1046 18.6046 19 17.5 19H3.5C2.39543 19 1.5 18.1046 1.5 17V3C1.5 1.89543 2.39543 1 3.5 1ZM9.5 7C9.5 8.10457 8.60457 9 7.5 9C6.39543 9 5.5 8.10457 5.5 7C5.5 5.89543 6.39543 5 7.5 5C8.60457 5 9.5 5.89543 9.5 7Z",
    stroke: "#39517D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.abdd90c3d5b9ec8f021b399f973de84d.svg";
export { ForwardRef as ReactComponent };